import type { ReactElement } from "react";
import { useMemo } from "react";

import { ContentStateWrapper } from "./ContentStateWrapper/ContentStateWrapper";
import { ErrorContent } from "./ErrorContent/ErrorContent";
import { LoadingContent } from "./LoadingContent/LoadingContent";

interface IContentProps {
    isError: boolean;
    isLoading: boolean;
    isDataLoaded: boolean;
    onClose: () => void;
    onCancelClick: () => void;
    onSubmitButtonClick: () => void;
    packageTitle?: string;
    children: ReactElement | null;
}

export const ContentStateRenderer = ({
    isError,
    isLoading,
    isDataLoaded,
    children,
    onClose,
    onCancelClick,
    onSubmitButtonClick,
    packageTitle,
}: IContentProps): ReactElement => {
    const fallbackContent = useMemo(() => {
        if (isError) {
            return <ErrorContent />;
        }

        return <LoadingContent />;
    }, [isError]);

    return (
        <ContentStateWrapper
            onClose={onClose}
            onCancelClick={onCancelClick}
            isDataLoaded={isDataLoaded}
            onSubmitButtonClick={onSubmitButtonClick}
            isLoadingOrError={isLoading || isError}
            packageTitle={packageTitle}
        >
            {isLoading || isError ? fallbackContent : children}
        </ContentStateWrapper>
    );
};
